import { React, useEffect, useState } from "react";
import { Link } from "react-scroll";
import { useSearchParams } from "react-router-dom";
const apiBaseURL = process.env.REACT_APP_API_URL || `${window.location.origin}`;
export const Navigation = () => {
  const [postResultModalVisible, setPostResultModalVisible] = useState(false);
  const handlePostResultModal = (e) => {
    e.preventDefault();
    setPostResultModalVisible(true);
  };
  const [menuToggle, setMenuToggle] = useState();

  const [searchParams] = useSearchParams();
  const paramsMoble = searchParams.get("key")?.replace(/ /g, "+");
  const [matchResult, setMatchResult] = useState([]);

  useEffect(() => {
    validateMobileAndCheckCTEligibility();
  }, []);

  //Mobile number verification status API call
  const validateMobileAndCheckCTEligibility = async () => {
    const payload = { MobileNumber: paramsMoble };
    try {
      const response = await fetch(
        `${apiBaseURL}/api/DishKiCT/ValidateMobileAndCheckCTEligibility`,
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(payload),
        },
      );
      if (!response.ok)
        throw new Error(`HTTP error! Status: ${response.status}`);
      const data = await response.json();
      if (data.resultStatus === "Success") {
        setMenuToggle(data.result.mobileNumber);
        const mobileNumber = data.result.mobileNumber;
        getPastMatchResults(mobileNumber);
      }
    } catch (error) {
      console.error("Error validating mobile number:", error);
    }
  };

  const getPastMatchResults = async (mobileNumber) => {
    try {
      const payload = { MobileNumber: mobileNumber };
      const response = await fetch(
        `${apiBaseURL}/api/DishKiCT/GetContestResult`,
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(payload),
        },
      );

      if (!response.ok)
        throw new Error(`HTTP error! Status: ${response.status}`);

      const data = await response.json();
      setMatchResult(data?.result || []);
    } catch (error) {
      console.error("Error fetching match results:", error);
    }
  };

  return (
    <>
      <nav className="navbar navbar-expand p-0 mb-0 championsTrophyNavigation">
        <a className="navbar-brand custom-logo" href="https://www.vzy.one/">
          <img
            src="./Images/logo.svg"
            alt="My Logo"
            className="img-fluid clas-of-logo"
          />
        </a>

        <div className="d-flex align-items-center justify-content-between flex-fill">
          <ul className="navbar-nav mr-auto">
            <li className="nav-item active">
              <Link className="nav-link" to="home" smooth={true} duration={500}>
                Home
              </Link>
            </li>
            <li className="nav-item">
              <Link
                className="nav-link"
                to="howToPlay"
                smooth={true}
                duration={500}
              >
                How To Play?
              </Link>
            </li>

            <li className="nav-item">
              <Link className="nav-link" to="faq" smooth={true} duration={500}>
                FAQs
              </Link>
            </li>
          </ul>
          {menuToggle ? (
            <div className="postResult">
              <a href="#" onClick={handlePostResultModal}>
                Check Past Results
              </a>
            </div>
          ) : (
            ""
          )}
        </div>
      </nav>

      <div
        className={`backdrop ${postResultModalVisible ? "show" : "fade"}`}
      ></div>
      <div
        className={`modal championsTrophyTermConditionModal ${
          postResultModalVisible ? "show" : "fade"
        }`}
        id="exampleModal"
        tabindex="-1"
        aria-labelledby="exampleModalLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-lg">
          <div className="modal-content">
            <div className="modal-header-custom">
              <h5 className="modal-title" id="exampleModalLabel">
                Past Matches Results
              </h5>
              <button
                type="button"
                className="close-custom"
                data-dismiss="modal"
                aria-label="Close"
              >
                <span
                  aria-hidden="true"
                  onClick={() => setPostResultModalVisible(false)}
                >
                  &times;
                </span>
              </button>
            </div>
            <div className="modal-body">
              <div className="modal-card">
                <table className="table table-borderless">
                  <thead>
                    <tr>
                      <th>Match Name</th>
                      <th>Date</th>
                      <th>Status</th>
                      <th>Assured Gift</th>
                      <th>Winning Gift</th>
                    </tr>
                  </thead>
                  <tbody>
                    {matchResult?.length > 0 ? (
                      matchResult.map((item, index) => (
                        <tr key={index}>
                          <td>{item.matchName}</td>
                          <td>{new Date(item.contestDate).toLocaleString()}</td>
                          <td>
                            <span
                              className={
                                item.status === "won"
                                  ? "success-badge"
                                  : "lost-badge"
                              }
                            >
                              {item.status}
                            </span>
                          </td>
                          <td>
                            <ul className="championsTrophyCoupons">
                              {item.assuredGift?.map((ag, idx) => (
                                <li key={idx}>
                                  {ag.reward} off on {ag.companyName} - Coupon:{" "}
                                  {ag.couponCode}
                                </li>
                              ))}
                            </ul>
                          </td>
                          <td>
                            <ul className="championsTrophyCoupons">
                              {item.winningGift?.map((wg, idx) => (
                                <li key={idx}>
                                  {wg.reward} off on {wg.companyName} - Coupon:{" "}
                                  {wg.couponCode}
                                </li>
                              ))}
                            </ul>
                          </td>
                        </tr>
                      ))
                    ) : (
                      // Show "No Results Found" when matchResult is empty
                      <tr>
                        <td colSpan="5" className="text-center">
                          No Results Found
                        </td>
                      </tr>
                    )}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
